<template>
    <v-btn outlined color="secondary" @click="handleClick" :disabled="disabled" :loading="loading">
        {{ $t(label) }}
        <v-icon v-if="icon != '' && icon != null" style="color: var(--v-white_highlight-base);">{{ icon }}</v-icon>
    </v-btn>
</template>
<script>
    export default {
        props: [
            'label',
            'icon',
            'disabled',
            'loading'
        ],
        data() {
            return {}
        },
        methods: {
            handleClick() {
                this.$emit('click')
            }
        }
    }
</script>